import React, { useRef, useState, useEffect } from "react";
import style from "./PruebaScroll.module.css"; // Para estilos adicionales opcionales
import { getCategoriasConTiposYProductos } from "../../repositorios/cartaService"; // Asegúrate de que esta ruta sea correcta

const sections = [
  "Inicio",
  "Servicios",
  "Portafolio",
  "Contacto",
  "Inicio",
  "Servicios",
  "Portafolio",
  "Contacto",
];

/**
 *
 * @description Componente que muestra un scroll horizontal de tabs y un scroll vertical de secciones.
 */

export default function Prueba() {
  const sectionRefs = useRef([]);
  const tabContainerRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);

  // Scroll a sección al hacer clic en un tab
  const scrollToSection = (index) => {
    sectionRefs.current[index]?.scrollIntoView({ behavior: "smooth" });
  };

  // Centrar tab activo
  const centerTab = (index) => {
    const container = tabContainerRef.current;
    const tab = container?.children[index];
    if (container && tab) {
      const scrollTo =
        tab.offsetLeft - container.offsetWidth / 2 + tab.offsetWidth / 2;
      container.scrollTo({ left: scrollTo, behavior: "smooth" });
    }
  };

  async function ObtenerCategorias() {
    getCategoriasConTiposYProductos().then((data) => {
      console.log("Todo anidado:", data);
      // setCategorias(data) o lo que necesites
    });
  }

  // Detectar qué sección está visible
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const visibleSection = entries.find((entry) => entry.isIntersecting);
        if (visibleSection) {
          const index = Number(visibleSection.target.dataset.index);
          setActiveIndex(index);
          centerTab(index);
        }
      },
      { threshold: 0.6 }
    );

    sectionRefs.current.forEach((section) => observer.observe(section));
    return () => observer.disconnect();
  }, []);

  // ##################################################################################

  return (
    <div>
      <div
        onClick={ObtenerCategorias}
        style={{ cursor: "pointer", color: "blue" }}
      >
        Obtener categorías
      </div>
      {/* Tabs horizontales */}
      <div
        ref={tabContainerRef}
        className={style.tabs}
        style={{
          display: "flex",
          overflowX: "auto",
          whiteSpace: "nowrap",
          borderBottom: "1px solid #ccc",
          position: "sticky", // Hace que los tabs sean sticky
          top: 0, // Se quedan pegados en la parte superior
          background: "#fff", // Fondo blanco para que no se superpongan con el contenido
          zIndex: 1000, // Asegura que los tabs estén por encima del contenido
        }}
      >
        {sections.map((section, index) => (
          <div
            key={index}
            onClick={() => scrollToSection(index)}
            style={{
              padding: "1rem",
              cursor: "pointer",
              borderBottom: activeIndex === index ? "2px solid blue" : "none",
              fontWeight: activeIndex === index ? "bold" : "normal",
              flex: "0 0 auto",
            }}
          >
            {section}
          </div>
        ))}
      </div>

      {/* Contenido scroll vertical */}
      <div style={{ height: "100vh", overflowY: "scroll" }}>
        {sections.map((title, index) => (
          <section
            key={index}
            ref={(el) => (sectionRefs.current[index] = el)}
            data-index={index}
            style={{
              height: "100vh",
              padding: "2rem",
              borderBottom: "1px solid #eee",
              background: index % 2 === 0 ? "#f9f9f9" : "#fff",
            }}
          >
            <h2>{title}</h2>
            <p>Contenido de la sección {title}</p>
          </section>
        ))}
      </div>
    </div>
  );
}
